import { gql } from '@apollo/client'

/** 权益卡 */
export const GET_AIEQUITY_LIST = gql`
  query getAiEquityList {
    accountModule {
      myCard: userMemberCardList {
        cardType
        startTime
        endTime
        cardRight {
          name
          num
          rightType
        }
        holdCardInfo {
          name
          num
          endTime
          rightType
        }
        name
        termShowInfo {
          desc
        }
      }
      buyCard: buyMemberCardList {
        cardRight {
          name
          num
          rightType
          accountCycleType
        }
        cardRuleInfo
        cardType
        hold
        name
        price
        showPrice
        monthNum
        allowModel
      }
    }
  }
`
